import React from 'react'
import { ChartProps, ChartType } from './type'
import { Box, BoxProps, Flex, Heading, Stack, IconButton } from '@chakra-ui/core'
import { BarChart, PieChart } from '.'
import { FaChartArea, FaChartBar, FaChartLine, FaChartPie } from 'react-icons/fa'
import LineChartComponent from './LineChartComponent'
import AreaChartComponent from './AreaChartComponent'
import { StatCardProps, Stats } from '../Stats'

type ChartSwitchProps = {
  defautChartType?: ChartType
  stats?: StatCardProps[]
} & ChartProps &
  BoxProps

const chartMap = {
  bar: {
    component: BarChart,
    icon: FaChartBar
  },
  pie: {
    component: PieChart,
    icon: FaChartPie
  },
  line: {
    component: LineChartComponent,
    icon: FaChartLine
  },
  area: {
    component: AreaChartComponent,
    icon: FaChartArea
  }
}

const ChartSwitch: React.FC<ChartSwitchProps> = ({
  defautChartType,
  title,
  action,
  stats,
  ...rest
}) => {
  const [chartType, setChartType] = React.useState<ChartType>(defautChartType || 'bar')

  const ChartComponent = chartMap[chartType].component || BarChart

  return (
    <Box flex={1} p={4} rounded="md" bg="white">
      <Flex justify="space-between" w="100%" align="center" mb={8} px={8}>
        <Heading size="xs" mb={3}>
          {title}
        </Heading>
        <Stack spacing={4} direction="row">
          {Object.keys(chartMap).map((key) => {
            const { icon: ChartIcon } = (chartMap as any)?.[key]
            const isActive = chartType === key
            return (
              <IconButton
                aria-label={key}
                key={key}
                icon={ChartIcon}
                size="sm"
                {...{
                  variantColor: isActive ? 'green' : 'gray',
                  bg: isActive ? 'green.100' : 'gray.50',
                  color: isActive ? 'green.600' : 'gray.500'
                }}
                rounded="full"
                onClick={() => setChartType(key as ChartType)}
              />
            )
          })}
          {action}
        </Stack>
      </Flex>
      {stats && <Stats stats={stats} alignItems="flex-start" />}
      <ChartComponent {...rest} />
    </Box>
  )
}

export default ChartSwitch
